import React from "react";
import { colors } from "../../../../theme/color";
import Buttons from "../../../Button/button.component";
import Wave from "../../../../assets/icons/wave.png";

import {
  ContentWrapperCon,
  PaymentLinkHeader,
  HelloSpan,
  PaymentLinkHeaderBeneathText,
  PaymentLinkHeaderText,
  SecondContWrapper,
  PaymentLinkButtonContainer,
  Name,
} from "./homeHeadd.styles";
import { RootState } from "../../../../store/rootReducer";

import { useQuery } from "@apollo/client";
import { GET_USER_BY_ID } from "../../../../graphql/queries/userManagement";
import { useSelector } from "react-redux";

const Index = () => {
  const id = useSelector((state: RootState) => state.user?.user.id);

  const {
    loading: queryLoading,
    error: queryError,
    data: queryData,
  } = useQuery(GET_USER_BY_ID);

  const userDetails = queryData?.getUserById;

  return (
    <ContentWrapperCon>
      <SecondContWrapper>
        <PaymentLinkHeader>
          <PaymentLinkHeaderText>
            <HelloSpan>Hello,</HelloSpan>
            <Name>
              {userDetails?.fullName ? userDetails.fullName : ""}
            </Name>{" "}
            <img src="/assets/icons/wave.png" alt="wave" />
          </PaymentLinkHeaderText>
          <PaymentLinkHeaderBeneathText>
            Let’s explore fipay together
          </PaymentLinkHeaderBeneathText>
        </PaymentLinkHeader>

        <PaymentLinkButtonContainer>
          <Buttons
            label="Fund Account"
            width="95%"
            height="44px"
            cursor="pointer"
            border="10px"
            color={colors.ButtonBackgroundColors.primaryDefaultButton}
            disabled={true}
          />
          <Buttons
            label="Withdraw"
            width="95%"
            height="44px"
            cursor="pointer"
            border="10px"
            // borderLine="1px solid #00A603"
            color={colors.neutral.cultured}
            // textColor="green"
            disabled={true}
          />
        </PaymentLinkButtonContainer>
      </SecondContWrapper>
    </ContentWrapperCon>
  );
};

export default Index;
